import React, { useState, useEffect } from "react";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import {Tag } from "antd";

const ExpenseSummarybyCategory = (props) => {
    const parentDatas = props;
  const [expandedRows, setExpandedRows] = useState(null);

    const allowExpansionPurchaseVendor = (rowData) => {
        return rowData.purchaseExpensesList.length;
      };
    const renderStatusColumn = (rowData) => {
        let status = rowData.purchaseStatus?.toUpperCase();
        let statusClass;
        switch (status) {
          case "OPEN":
            statusClass = "orange";
            break;
          case "PARTIALLY PAID":
            statusClass = "processing";
            break;
          case "PAID":
            statusClass = "green";
            break;
          case "DRAFT":
            statusClass = "purple";
            break;
          case "OVERDUE":
            statusClass = "error";
            break;
          default:
            statusClass = "cyan";
        }
        return (
          <Tag bordered={false} color={statusClass}>
            {status}
          </Tag>
        );
      };

      const expansionPurchaseVendor = (data) => {
        return (
          <div className="">
            <DataTable
              stripedRows
              value={data.purchaseExpensesList}
              className="expand-table"
            >
              <Column field="purchaseCode" header="Purchase Code"></Column>
              <Column field="companyName" header="Company Name"></Column>
              <Column field="email" header="Email"></Column>
              <Column
                field="balancePayment"
                header=" Balance Amount"
                className="text-end amount-align"
                body={(a) => parentDatas.currency + " " + a?.balancePayment.toFixed(2)}
              ></Column>
              <Column
                field="totalAmount"
                header=" Total Amount"
                className="text-end amount-align"
                body={(a) => parentDatas.currency + " " + a?.totalAmount.toFixed(2)}
              ></Column>
              <Column
                field="renderStatusColumn"
                header="Status"
                body={renderStatusColumn}
              ></Column>
            </DataTable>
          </div>
        );
      };
  return (
    <div className="card">
            <DataTable value={parentDatas.expenseSummaryByCat} expandedRows={expandedRows}
                 onRowToggle={(e) => setExpandedRows(e.data)} tableStyle={{ minWidth: '100%' }} rowExpansionTemplate={expansionPurchaseVendor}>
            <Column expander={allowExpansionPurchaseVendor} style={{ width: "4rem" }} />
            <Column field="coaCategory" header="Category name" style={{width:"20%"}} ></Column>
            <Column field="purchaseAmount" header="Amount" className="text-end amount-align" body={(a) => parentDatas.currency + " " + a.purchaseAmount.toFixed(2)} ></Column>
                <Column field="purchaseWithTax" header="Amount with Tax" className="text-end amount-align" body={(a) => parentDatas.currency + " " + a.totalAmount.toFixed(2)}></Column>
                <Column field="totalAmount" header="Total Amount" className="text-end amount-align" body={(a) => parentDatas.currency + " " + a.balancePayment.toFixed(2)}></Column>
            </DataTable>
        </div>
  )
}

export default ExpenseSummarybyCategory